export const sendGenericSocketNotification = (socketConnection, reCreateSocket, options) => {
    const { 
        userId, 
        userIds, 
        classId, 
        notificationCode, 
        payload = {} 
    } = options;

    if (!notificationCode) {
        console.error('notificationCode is required');
        return false;
    }

    if (!userId && !userIds && !classId) {
        console.error('At least one of userId, userIds, or classId must be provided');
        return false;
    }

    if (!socketConnection) {
        console.warn('Socket connection not available');
        return false;
    }

    try {
        const socketData = {
            code: 'generic_notification',
            userId,
            userIds,
            classId,
            notificationCode,
            payload
        };
        
        if (socketConnection.readyState === 3) {
            reCreateSocket();
            setTimeout(() => {
                if (socketConnection.readyState === 1) {
                    socketConnection.send(JSON.stringify(socketData));
                }
            }, 2000);
        } else if (socketConnection.readyState === 1) {
            socketConnection.send(JSON.stringify(socketData));
            return true;
        } else {
            console.warn('Socket connection not ready, readyState:', socketConnection.readyState);
            return false;
        }
    } catch (error) {
        console.error('Failed to send generic socket notification:', error);
        return false;
    }
};

export const SOCKET_NOTIFICATION_CODES = {
    PERMISSIONS_UPDATED: 'permissions_updated',
    USER_ROLE_CHANGED: 'user_role_changed',
    ORGANIZATION_UPDATED: 'organization_updated',
    CLASS_UPDATED: 'class_updated',
    BOOK_ACCESS_CHANGED: 'book_access_changed',
    SETTINGS_UPDATED: 'settings_updated',
    FEATURE_TOGGLED: 'feature_toggled'
};

